@if (history() && history()!.length >= 2 && percentageChange() !== undefined) {
  <div class="value-history-container">
    <svg
      class="trend-line-svg"
      [attr.width]="SVG_WIDTH"
      [attr.height]="SVG_HEIGHT"
      [attr.viewBox]="'0 0 ' + SVG_WIDTH + ' ' + SVG_HEIGHT"
      preserveAspectRatio="none">
      @for (segment of pathSegments(); track $index) {
        <path
          [attr.d]="segment.path"
          [attr.stroke]="getSegmentColor(segment.color)"
          [attr.fill]="'none'"
          [attr.stroke-width]="1.5"
          [attr.stroke-linecap]="'round'"
          [attr.stroke-linejoin]="'round'"
          [attr.stroke-dasharray]="segment.isDotted ? '2,2' : 'none'"/>
      }
    </svg>
    <span class="percentage-text" [style.color]="getColor()">
      {{ getFormattedPercentage() }}
    </span>
  </div>
  <!-- <div class="value-history-since extra-info">
    since {{ history()![history()!.length - 1].ts | date:'MM/dd HH:mm' }}
  </div> -->
} @else {
  <div class="value-history-since extra-info">
    No price history data
  </div>
}
